module.exports = __webpack_public_path__ + "img/m-logo.85397cac.png";